import { FielmannLogo } from "@/components/brand/FielmannLogo";
import { useI18n } from "@/i18n";

import { LanguageSwitcher } from "./LanguageSwitcher";
import { getHomeLink } from "./site-links";

/**
 * Site header shown on every auth screen.
 *
 * The centered Fielmann wordmark links to the country/language homepage for the
 * active locale. For Switzerland locales the language switcher is shown above
 * the logo on narrow viewports, and beside the logo at `header-inline`.
 *
 * On mobile only the logo bar is sticky (tabs stick beneath it). The switcher
 * sits above that sticky bar so it scrolls away after language selection.
 */
export function Header() {
  const { locale, messages, showLanguageSwitcher } = useI18n();
  const homeLink = getHomeLink(locale);

  return (
    <>
      {/* Mobile / stacked: above the sticky logo, so it scrolls away. */}
      {showLanguageSwitcher ? (
        <div className="flex w-full justify-center bg-background-secondary px-1 py-0.5 header-inline:hidden">
          <LanguageSwitcher />
        </div>
      ) : null}

      <header className="sticky top-0 z-30 w-full border-b border-line-stroke-base bg-background-secondary sm:static sm:z-auto">
        <div className="relative mx-auto flex h-3 w-full max-w-[1365px] items-center justify-center px-1 sm:h-[72px] sm:w-[calc(100%-80px)] sm:px-1.5">
          {/* Wide screens: same absolute placement as before, beside the logo. */}
          {showLanguageSwitcher ? (
            <div className="absolute right-0 top-1/2 z-50 hidden -translate-y-1/2 header-inline:block">
              <LanguageSwitcher />
            </div>
          ) : null}

          <a
            href={homeLink.href}
            className="no-underline"
            aria-label={messages.shared.header.logoAriaLabel}
          >
            <FielmannLogo size="header" />
          </a>
        </div>
      </header>
    </>
  );
}
